import firebase from 'firebase';

const config = {
    apiKey: "AIzaSyBinC1blJva7orZBn0mYjavtBPbeAB1Fx8",
    authDomain: "fun-food-friends-6ca8e.firebaseapp.com",
    databaseURL: "https://fun-food-friends-6ca8e.firebaseio.com",
    projectId: "fun-food-friends-6ca8e",
    storageBucket: "fun-food-friends-6ca8e.appspot.com",
    messagingSenderId: "544509681520"
  };

  firebase.initializeApp(config);

export const provider = new firebase.auth.GoogleAuthProvider();
export const auth = firebase.auth();
export default firebase;



// WEBPACK FOOTER //
// ./src/firebase.js